/** 기본설정 — 업체·부서 통합 */
export const COMPANY_DEPARTMENT_CATEGORIES = [
    {
        id: "company",
        label: "업체관리",
        title: "업체관리",
        description: "협력업체·고객사 정보를 조회·등록·관리합니다.",
        route: "/settings/company",
    },
    {
        id: "department",
        label: "부서관리",
        title: "부서관리",
        description: "조직 부서 구조와 부서 정보를 관리합니다.",
        route: "/settings/department/list",
    },
];

export const COMPANY_DEPARTMENT_ROUTE_CATEGORY = Object.fromEntries(
    COMPANY_DEPARTMENT_CATEGORIES.map((item) => [item.route, item.id]),
);

/** 기본설정 — 사용자·그룹 통합 */
export const USER_ACCOUNT_GROUP_CATEGORIES = [
    {
        id: "userAccount",
        label: "사용자관리",
        title: "사용자관리",
        description: "시스템 사용자 계정을 조회·등록·관리합니다.",
        route: "/settings/userAccount/list",
    },
    {
        id: "userGroup",
        label: "사용자그룹관리",
        title: "사용자그룹관리",
        description: "사용자 그룹, 그룹별 사용자·메뉴 권한을 관리합니다.",
        route: "/settings/usergroup/list",
    },
];

export const USER_ACCOUNT_GROUP_ROUTE_CATEGORY = Object.fromEntries(
    USER_ACCOUNT_GROUP_CATEGORIES.map((item) => [item.route, item.id]),
);

export function pickBasicSettingsCategory(categories, preferredId, routeCategoryMap, pathname) {
    const fromRoute = routeCategoryMap[pathname];
    const candidate = fromRoute ?? preferredId ?? categories[0]?.id;
    return categories.some((item) => item.id === candidate) ? candidate : categories[0]?.id;
}
